
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.533 10.187c0-.82-.067-1.417-.21-2.037H9.965v3.698h5.492c-.11.92-.709 2.303-2.038 3.233l-.018.124 2.958 2.292.205.02c1.883-1.738 2.968-4.296 2.968-7.33z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M9.966 19.931c2.69 0 4.95-.886 6.6-2.414l-3.146-2.436c-.841.587-1.97.997-3.454.997-2.636 0-4.872-1.739-5.67-4.141l-.117.01-3.076 2.38-.04.112a9.958 9.958 0 008.903 5.492z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M4.296 11.937a6.135 6.135 0 01-.332-1.971c0-.687.122-1.351.321-1.971l-.005-.132-3.115-2.42-.102.05A9.975 9.975 0 000 9.965c0 1.605.388 3.122 1.063 4.473l3.233-2.502z","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M9.966 3.853c1.871 0 3.133.809 3.853 1.484l2.812-2.746C14.904.985 12.656 0 9.966 0a9.958 9.958 0 00-8.903 5.492l3.222 2.503c.809-2.403 3.045-4.142 5.68-4.142z","fill":"#EB4335"}})])
          )
        }
      }
    